import Swiper from "swiper/bundle";
export default class Carousel {
  constructor(component) {
    this.element = component;

    this.options = {
      slidesPerView: 1,
      spaceBetween: 20,

      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
      },
      navigation: {
        nextEl: this.element.querySelector(".swiper-button-next"),
        prevEl: this.element.querySelector(".swiper-button-prev"),
      },
    };
    this.init();
  }
  setOptions() {
    if ("split" in this.element.dataset) {
      this.options.breakpoints = {
        768: { slidesPerView: 2.2, centeredSlides: true },
      };
    }
    if ("autoplay" in this.element.dataset) {
      this.options.autoplay = {
        delay: 5000,
        pauseOnMouseEnter: true,
        pauseOnInteraction: false,
      };
    }
    if ("loop" in this.element.dataset) {
      this.options.loop = true;
    }
    if ("slides" in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.slides) || this.options.slidesPerView;
    }
  }
  init() {
    this.setOptions();
    new Swiper(this.element, this.options);
  }
}
